import { render, staticRenderFns } from "./DeliveryMethodsAdditionalInformation.vue?vue&type=template&id=635674d0&"
import script from "./DeliveryMethodsAdditionalInformation.vue?vue&type=script&lang=js&"
export * from "./DeliveryMethodsAdditionalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports